import React, { Component, Fragment } from "react";
import { Link, Redirect } from "react-router-dom";

import Cookies from "react-cookies";

import Modal from "react-bootstrap/Modal";

import UBXFormText from "./../../ubx/form/input";
import UBXButton from "./../../ubx/button";
import Divider from "./../../ubx/divider";

import { Captcha } from "./../../../config/external";
import { borrowerLogin, borrowerGetProfile, borrowerDocuments, borrowerReSend } from "./../../../api/borrower";

import ReCaptcha from "./../../../helpers/recaptcha";
import { getENV, getPagePath } from "./../../../helpers/system";

import User from "./../user";

import { UserCookieVarSignUpEmail } from "./../../../const/user";

export default class LoginModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userLoggedIn: false,
            email: "",
            password: "",
            captcha: "",
            formReady: false,
            userId: null,
            error: false,
            isBusy: false,
            recaptchaRef: null,
            redirect: false,
        };
    }

    async loginUser(userData) {
        const { recaptchaRef } = this.state;
        try {
            const userLoginResponse = await borrowerLogin(userData);

            const { data: responseData } = userLoginResponse;

            const { AuthenticationResult: authenticationResult } = responseData;

            User.set(authenticationResult);

            const { ExpiresIn: maxAge } = authenticationResult;

            await this.setState({
                userLoggedIn: true,
                isBusy: false,
            });

            await this.getUserProfile(maxAge);
            await this.getUserProfilePhoto(maxAge);
            await this.onSuccess();
        } catch (error) {
            recaptchaRef.current?.reset();
            this.handleError(error);
        }
    }

    async getUserProfile(maxAge = false) {
        const { extensions } = this.props;
        const { FeatureFlags = false } = extensions || {};

        const userProfileResponse = await borrowerGetProfile();

        const { data: responseData } = userProfileResponse;

        User.saveProfile(responseData, maxAge);

        if (FeatureFlags) {
            const { "borrower_email": userId = null } = responseData;

            const featureFlags = await FeatureFlags;

            featureFlags.setContextField("userId", userId);
        }
    }

    async getUserProfilePhoto(maxAge = false) {
        const userDocumentsResponse = await borrowerDocuments();

        const { data: documentsData } = userDocumentsResponse;

        const profilePhoto = documentsData.find((doc) => doc.code === "profile_photo");

        if (profilePhoto !== undefined) {
            const avatar = profilePhoto["value"];

            User.setProfilePhoto(avatar, maxAge);
        }
    }

    async componentDidMount() {
        await this.setState({ recaptchaRef: React.createRef() });
    }

    onClose(e) {
        const { onClose = false } = this.props;

        if (onClose) {
            onClose(e);
        }
    }

    onOpenForgotPassword(e) {
        const { onOpenForgotPassword = false } = this.props;

        if (onOpenForgotPassword) {
            onOpenForgotPassword(e);
        }
    }

    onChange(name, value) {
        this.setState({ [name]: value, error: false });

        const { email, password, captcha } = this.state;

        let formReady = false;
        if (email !== "" && password !== "" && captcha !== "" && captcha !== null) {
            formReady = true;
        }

        this.setState({ formReady });
    }

    async handleError(error) {
        if (error) {
            const { response } = error;

            if (response) {
                const { status } = response;

                switch (status) {
                    case 412: {
                        const expires = new Date();
                        expires.setDate(expires.getDate() + 1);
                        Cookies.save(UserCookieVarSignUpEmail, this.state.email, { expires });

                        try {
                            const { data: reverifyData = false } = await borrowerReSend({ email: this.state.email });

                            let redirect = getPagePath("UserSignUpStatus", { status: "reverify" });

                            if (reverifyData) {
                                const { reference_number: referenceNumber = "" } = reverifyData;

                                redirect = {
                                    pathname: redirect,
                                    state: { referenceNumber },
                                };
                            }

                            this.setState({ redirect });
                        } catch (e) {
                            let errorMessage = "Error in resending e-mail.";
                            if (e.response) {
                                const { data: responseData = {} } = e.response;
                                const { data = false } = responseData;

                                if (data) {
                                    const { message } = data;

                                    errorMessage = message;
                                }
                            }
                            await this.setState({ error: errorMessage, isBusy: false });
                        }
                        break;
                    }
                    case 400:
                    default: {
                        const { data: responseData } = response;
                        if (responseData) {
                            const { data = false } = responseData;

                            let errorMessage = "An error has occurred";
                            if (data) {
                                const { message } = data;
                                errorMessage = message;
                            }

                            this.setState({
                                error: errorMessage,
                                isBusy: false,
                                formReady: false,
                            });
                        } else {
                            alert(`An error occured:\n\n${response}`);
                        }
                        break;
                    }
                }
            }
        }
    }

    async onSubmit(e) {
        if (e) {
            e.preventDefault();
        }

        const { email, password, captcha, formReady } = this.state;

        const userData = {
            username: email.toLowerCase(),
            password,
            captcha,
        };

        this.setState({
            isBusy: true,
        });

        if (formReady) {
            await this.loginUser(userData);
        }

        return false;
    }

    async onSuccess() {
        const { onSuccess = false } = this.props;

        if (onSuccess) {
            onSuccess();
        } else {
            window.location.reload();
        }
    }

    renderLoginOptions() {
        let renderedLoginOptions = [];

        return (
            <Fragment>
                {renderedLoginOptions.length ? (
                    <Fragment>
                        <div className="user-fields">
                            <Divider text="or" />
                        </div>
                        <div className="user-fields">{renderedLoginOptions}</div>
                    </Fragment>
                ) : null}
            </Fragment>
        );
    }

    redirect() {
        const { redirect } = this.state;

        return redirect ? <Redirect to={redirect} /> : false;
    }

    render() {
        const { show = false, showSignUp = true, type = false } = this.props;
        const { error, isBusy, formReady, recaptchaRef } = this.state;

        const { key: captchaKey = "" } = Captcha[getENV()] || {};

        const customClassNames = [];
        if (window.zE) {
            customClassNames.push("has-zendesk");
        }

        let signUpLink = getPagePath("UserSignUp");
        if (type) {
            customClassNames.push(type);
            signUpLink = `${getPagePath("UserSignUp")}?motorcycles`;
        }

        return (
            this.redirect() || (
                <Modal
                    className={type}
                    id="login-modal"
                    show={show}
                    backdrop="static"
                    centered
                    onHide={(e) => this.onClose(e)}
                >
                    <Modal.Header closeButton closeLabel="Close Login Modal">
                        <Modal.Title>Log in</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div id="user-login" className={customClassNames.join(" ")}>
                            <form id="login-form" onSubmit={(e) => this.onSubmit(e)}>
                                <div className="user-fields">
                                    <UBXFormText
                                        id="login-email"
                                        type="email"
                                        name="email"
                                        label="Email"
                                        required={true}
                                        onChange={(name, value) => this.onChange(name, value)}
                                        errorMessage={"Invalid email address"}
                                    />
                                </div>
                                <div className="user-fields">
                                    <UBXFormText
                                        id="login-password"
                                        type="password"
                                        name="password"
                                        label="Password"
                                        required={true}
                                        onChange={(name, value) => this.onChange(name, value)}
                                        // onSubmit={(e) => this.onSubmit(e)}
                                    />
                                </div>
                                <div className="user-fields recover-password">
                                    <Link to="/" onClick={(e) => this.onOpenForgotPassword(e)} data-dismiss="modal">
                                        Forgot Password
                                    </Link>
                                </div>
                                {/* <div className="user-fields">
                                <UBXFormCheck id="login-remember" required={false}> Remember me </UBXFormCheck>
                            </div> */}
                                <div className="user-fields user-captcha">
                                    <ReCaptcha
                                        // key={`${email}+${password}`}
                                        ref={recaptchaRef}
                                        sitekey={captchaKey}
                                        onChange={(token) => this.onChange("captcha", token)}
                                    />
                                </div>
                                <div className="user-fields">
                                    <UBXButton
                                        id="login-button"
                                        className={type}
                                        type="primary"
                                        block={true}
                                        size="large"
                                        submit={true}
                                        disabled={isBusy || !formReady}
                                        form="login-form"
                                    >
                                        Log in
                                    </UBXButton>
                                </div>
                            </form>
                            {this.renderLoginOptions()}
                            {error ? (
                                <em className="login-error" title={error}>
                                    {error}
                                </em>
                            ) : (
                                ""
                            )}
                            {showSignUp ? (
                                <p>
                                    Don’t have an account yet? <Link to={signUpLink}>Sign Up</Link>
                                </p>
                            ) : (
                                ""
                            )}
                        </div>
                    </Modal.Body>
                </Modal>
            )
        );
    }
}
